import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import Toggle from './../Toggle';
import Disclaimer from '../Disclaimer';
import { aftcabinImageOptions } from './views/aftcabin'

class AftCabin extends Component {
    constructor(props) {
		super(props);
		this.handleShelvingChange = this.handleShelvingChange.bind(this);
		this.handleSeaBerthChange = this.handleSeaBerthChange.bind(this);
	}


	handleShelvingChange(event) {
		let configuration = this.props.configuration;
		configuration.AftCabinLayout = event.target.checked ? this.props.aftCabinOptions[1] : this.props.aftCabinOptions[0];

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}

	handleSeaBerthChange(event) {
		let configuration = this.props.configuration;
		configuration.AftCabinLayout = event.target.checked ? this.props.aftCabinOptions[2] : this.props.aftCabinOptions[0];

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}
    render() {
		let imageOptions = aftcabinImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>


					<h1><Trans defaults='Aft Cabins' /></h1>
					<h2><Trans defaults='Furniture' /></h2>
					<p><Trans defaults='Standard of the X4<sup>3</sup> is double berth in both aft cabins. Optional is 2 x freeboard hung sea berths in both cabins. Alternatively freeboard hung upper shelves in both aft cabins. ' /></p>


					
					<Toggle checked={this.props.configuration.AftCabinLayout.value === 2} onChange={this.handleShelvingChange}>
						<Trans defaults='Upper shelves' />
					</Toggle>

					<Toggle checked={this.props.configuration.AftCabinLayout.value === 3} onChange={this.handleSeaBerthChange}>
						<Trans defaults='Sea berth' />
					</Toggle>


                    <Disclaimer />
                   

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(AftCabin);


// WEBPACK FOOTER //
// ./src/X43MK2/AftCabin.js